import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "document",
    standalone: false
})
export class DocumentPipe implements PipeTransform {
  transform(document = "", obfuscate = false) {
    if (document) {
      let newDocument = document?.toString().replace(/[^A-Z0-9]/gi, "");

      switch (document.length) {
        case 4:
          newDocument = newDocument.replace(/(\d+)(\d{3})/, "$1.$2");
          break;
        case 5:
          newDocument = newDocument.replace(/(\d+)(\d{3})/, "$1.$2");
          break;
        case 6:
          newDocument = newDocument.replace(/(\d+)(\d{3})/, "$1.$2");
          break;
        case 7:
          newDocument = newDocument.replace(/(\d+)(\d{3})(\d{3})/, "$1.$2.$3");
          break;
        case 8:
          newDocument = newDocument.replace(/(\d+)(\d{3})(\d{3})/, "$1.$2.$3");
          break;
        case 9:
          newDocument = newDocument.replace(/(\d+)(\d{3})(\d{3})/, "$1.$2.$3");
          break;
        case 10:
          newDocument = newDocument.replace(/(\d+)(\d{3})(\d{3})(\d)/, "$1.$2.$3-$4");
          break;
        case 11:
          newDocument = newDocument.replace(
            /(\d+)(\d{3})(\d{3})(\d{2})/,
            "$1.$2.$3-$4",
          );
          break;
        case 12:
          newDocument = newDocument.replace(
            /([A-Z0-9]+)([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})/i,
            "$1.$2.$3/$4",
          );
          break;
        case 13:
          newDocument = newDocument.replace(
            /([A-Z0-9]+)([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/i,
            "$1.$2.$3/$4-$5",
          );
          break;
        case 14:
          newDocument = newDocument.replace(
            /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]+)/i,
            "$1.$2.$3/$4-$5",
          );
          break;
      }

      if (obfuscate) {
        newDocument = newDocument.replace(/(\d+\.\d+\.)\d{3}-(\d{2})/, "$1***-**"); // NOSONAR
      }

      return newDocument;
    }

    return document;
  }
}
